'use strict';

export class ProjectRequestIdentityCtrl
{
	$scope;
	$filter;
	$mdDialog;
	cfg;
	
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.cfg = jsDataService.get('cfgRequestIdentity', {maxFileSize: null, fileFilter: null, uploadUrl: null, dialogTitle: null, submitUrl: null});
	}
	
	actRequestIdentity(ev){
		

		const postElements = {
			comment: '',
			subject: '',
			attachments: []
		};

		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "$filter", 'notify', 'postElements', 'cfg', this.requestIdentityCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'esfasi/ng_comment_files.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				postElements: postElements,
				cfg: this.cfg
			}
		}).then((results) => {
			if(this.cfg?.submitUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.submitUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	requestIdentityCtrl($scope,$mdDialog, $filter, notify, postElements, cfg){
		$scope.cfg = cfg;
		$scope.dragClass = '';
		$scope.attfile = {
			file: {}
		};
		
		$scope.postElements = postElements;
		if(typeof($scope.postElements.attachments) === 'undefined'){
			$scope.postElements.attachments = [];
		}
		if(typeof($scope.postElements.comment) === 'undefined'){
			$scope.postElements.comment = '';
		}

		$scope.fileUploaded = function($file, $message, $flow){
			if($file.response.success){
				$scope.attfile.file.file_id = $file.response.fileId;
				$scope.attfile.file.done = true;
				$scope.saveAttachment($scope.attfile);
			}
		};

		$scope.filesAdded = function($files){
			return true;
		};

		$scope.fileAdded = function($file){
			const ext = $file.getExtension();
			if(typeof($scope.cfg.fileFilter[ext]) === 'undefined' || !$scope.cfg.fileFilter[ext]){
				notify($filter('tr')('file_wrong_format'), true);
				return false;
			}
			if(typeof($scope.cfg.maxFileSize) !== 'undefined' && $file.size > $scope.cfg.maxFileSize){
				notify($file.name + ' - ' + $filter('tr')('file_size_error'), true);
				return false;
			}
			if(!$scope.activeUpload()){
				return false;
			}
			$scope.addFlowFile($file);
			return true;
		};

		$scope.fileSubmited = function(){
			$scope.attfile.flow?.upload();
		};

		$scope.activeUpload = function(){
			return true;
		};

		$scope.classOnDrag = function(value){
			if($scope.activeUpload()){
				$scope.dragClass = value;
			}
		};

		$scope.classOffDrag = function(value){
			$scope.dragClass = value;
		};

		$scope.addFlowFile = function($file){
			let file = {
				file_id: '0',
				nrId: $file.uniqueIdentifier,
				file_name: $file.name,
				isFlow: true,
				flowFile: $file,
				done: false
			};
			$scope.attfile.file = file;
		};

		$scope.saveAttachment = function(attachment){
			let data = {
				file_id: attachment.file.file_id,
				title: attachment.file.file_name
			};
			$scope.postElements.attachments.push(data);
			$scope.attfile.file = {};
		};

		$scope.removeAttachment = function(ev, attachment){
			$scope.postElements.attachments = $filter('filter')($scope.postElements.attachments, {file_id: '!'+attachment.file_id}, true);
		};
		
		$scope.isValid = function(){
			if($scope.postElements.comment == ''){
				return false;
			}
			if($scope.postElements.attachments.length < 1){
				return false;
			}
			return true;
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			if(!$scope.isValid()) {
				return;
			}
			$mdDialog.hide($scope.postElements);
		};
	}
}
